import TranscriptRecordingLogic from "../../components/RecordingFeatures/TranscriptRecording";
import "../../css/app/aiResults.css";

const TranscriptRecordingPage = () => {

    return (
        <div className="vr-air-page">
            <TranscriptRecordingLogic />
        </div>
    );
};

export default TranscriptRecordingPage;
